import { BaseTag }   from "mixs/base/base_mixin";
import flatpickr from "flatpickr";
import visit from 'utilities/visit';
export class LogsCalendar extends BaseTag {
  init(){
    super.init();
    this.listenMount([this.onMountLogsCalendar])
  }
  onMountLogsCalendar() {
    const scope = this
    flatpickr(this.querySelector('input'), {
      dateFormat: "Y/m/d",
      onChange: function(selectedDates, dateStr, instance) {
        scope.onChangeDate(selectedDates, dateStr, instance)
      },
    })
  }
  onChangeDate(selectedDates, dateStr, instance){
    visit("/logs?d=" + dateStr)
  }
}
riot.mixin('logs.calendar', LogsCalendar as riot.TagMixin)
